/**
 * Temporary auth flow tracing. Filter DevTools console by: [llb-auth]
 *
 * Disable: localStorage.removeItem('LLB_AUTH_DEBUG')
 * Force enable (even in production build): localStorage.setItem('LLB_AUTH_DEBUG', '1')
 */
function isAuthDebugEnabled() {
  if (typeof window === "undefined" || !window.localStorage) {
    return process.env.NODE_ENV === "development";
  }
  const flag = window.localStorage.getItem("LLB_AUTH_DEBUG");
  if (flag === "0") return false;
  if (flag === "1") return true;
  return process.env.NODE_ENV === "development";
}

/**
 * @param {string} phase
 * @param {Record<string, unknown>} [detail]
 */
export function authLog(phase, detail) {
  if (!isAuthDebugEnabled()) return;
  try {
    const payload =
      detail && Object.keys(detail).length > 0 ? { phase, ...detail } : { phase };
    console.log("[llb-auth]", JSON.stringify(payload));
  } catch {
    console.log("[llb-auth]", phase, detail);
  }
}
